import { PaymentSchedule } from '../constants';

const FORM_DATA_KEY = 'form-data';
export const DTD_ID = 'dtd_id';
export const DTD_TEXT = 'dtd_text';

export interface SessionFormData {
  firstName: string;
  lastName: string;
  donorEmail: string;
  donationAmount: number;
  donationLevelId: number;
  paymentSchedule: PaymentSchedule;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  donationPersonalNote: string;
  donationDisplayName: string;
  hideDonationAmount: boolean;
  hideMyDisplayName: boolean;
  donorEmailOptIn: boolean;
  donationOtherAmount: number;
  isOtherAmountActive: boolean;
}

export const saveSessionFormData = (formData: SessionFormData) => {
  window.sessionStorage.setItem(FORM_DATA_KEY, JSON.stringify(formData));
};

/**
 * @description Gets form data that is persisted for the session
 */
export const getSessionFormData = (): SessionFormData | null => {
  const formData = window.sessionStorage.getItem(FORM_DATA_KEY);
  if (!formData) return null;

  return JSON.parse(formData || '') as SessionFormData;
};

/**
 * Determines if we should restore session data on the form.
 *
 * We do not want to do this if we are referred to the donation form from the fundraising center.
 */
export const shouldRestoreSession = (): boolean =>
  !document.referrer.toUpperCase().includes('/TR');
